import type { WithdrawalConfig } from '../../withdrawal.types.ts';

const WITHDRAWAL: WithdrawalConfig = {
  bankFields: ['accountNumber', 'bankCode', 'bankName', 'accountName'],
  accountNumber: { minDigits: 8, maxDigits: 8 },
  bankCode: { groupSizes: [2, 2, 2], trackName: 'Sort Code' },
};

export { WITHDRAWAL };
